import { BaseEitherError } from '@uniqkey-frontend/shared-app';

export class KeysManagerFailedToCreatePartnerUserKeysError extends BaseEitherError {}

export type TKeysManagerCreatePartnerUserKeysOperationErrors =
  KeysManagerFailedToCreatePartnerUserKeysError;
